import { render, staticRenderFns } from "./CustomerRegister.vue?vue&type=template&id=227ecd5d&"
import script from "./CustomerRegister.vue?vue&type=script&lang=ts&"
export * from "./CustomerRegister.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports